import { useAxiosConfig } from '@shared/api/AxiosConfigProvider';
import { useGroupAccountRetrieve } from '@shared/api/lib/group/group';

/**
 * Group dashboard context for the parent org: its own feature flags (drives
 * sidebar locking) plus the flat child-org list used by the global org filter.
 * Renders are gated on this query in the group context provider.
 */
export const useGetGroupAccount = () => {
  return useGroupAccountRetrieve({
    request: useAxiosConfig(),
  });
};
